import { Box, Image, useColorModeValue, chakra, Text, Flex } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';

interface Props {
  isCollapsed?: boolean;
  onClick?: (event: React.SyntheticEvent) => void;
  className?: string;
}

const NetworkLogo = ({ isCollapsed, onClick, className }: Props) => {

  const logoSrc = '/static/taostats.svg';
  const iconSrc = useColorModeValue(config.UI.navigation.icon.default, config.UI.navigation.icon.dark || config.UI.navigation.icon.default);
  const darkModeFilter = { filter: 'brightness(0) invert(1)' };
  const logoStyle = useColorModeValue({}, !config.UI.navigation.logo.dark ? darkModeFilter : {});
  const iconStyle = useColorModeValue({}, !config.UI.navigation.icon.dark ? darkModeFilter : {});

  return (
    <Flex alignItems="flex-end" gap={ 2 }>
      <Box
        className={ className }
        as="a"
        href={ route({ pathname: '/' }) }
        width={{ base: '81px', lg: isCollapsed === false ? '81px' : '30px', xl: isCollapsed ? '30px' : '81px' }}
        height={{ base: '24px', lg: isCollapsed === false ? '24px' : '30px', xl: isCollapsed ? '30px' : '24px' }}
        display="inline-flex"
        overflow="hidden"
        onClick={ onClick }
        flexShrink={ 0 }
        aria-label="Link to main page"
      >
        { /* big logo */ }
        <Image
          w="81px"
          h="auto"
          src={ logoSrc }
          alt="Taostats logo"
          display={{ base: 'block', lg: isCollapsed === false ? 'block' : 'none', xl: isCollapsed ? 'none' : 'block' }}
          style={ logoStyle }
        />
        { /* small logo */ }
        <Image
          w="auto"
          h="100%"
          src={ iconSrc }
          alt="Taostats logo"
          display={{ base: 'none', lg: isCollapsed === false ? 'none' : 'block', xl: isCollapsed ? 'block' : 'none' }}
          style={ iconStyle }
        />
      </Box>
      <Text color="white" fontSize="17px" fontWeight={ 100 }>EVM</Text>
    </Flex>
  );
};

export default React.memo(chakra(NetworkLogo));
